import UpdateShopSupplierRequestModelBase from '../_generated/modelBases/update-shop-supplier-request-model-base';

export default class UpdateShopSupplierRequestModel extends UpdateShopSupplierRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
